import { motion, AnimatePresence } from 'framer-motion'

import Spinner from '../Spinner.jsx'
import InfoIcon from '../icons/infocircle.svg?react'
import CrossIcon from '../icons/crosscircle.svg?react'
import CheckIcon from '../icons/checkcircle.svg?react'

export default function ValidatorIcon({ status, tooltip }) {
  const variants = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: { opacity: 1, scale: 1 },
  }

  let icon = null
  let key = null

  switch (status) {
    case 'idle':
      icon = <InfoIcon className="cursor-help size-4" style={{ color: "var(--color-secondary)" }} />
      key = 'idle'
      break
    case 'validating':
      icon = <Spinner className="text-secondary cursor-help" size="sm" />
      key = 'validating'
      break
    case 'valid':
      icon = <CheckIcon className="cursor-help size-4" style={{ color: "var(--color-success)" }} />
      key = 'valid'
      break
    default:
      icon = <CrossIcon className="cursor-help size-4" style={{ color: "var(--color-error)" }} />
      key = 'invalid'
  }

  return (
    <div className="relative group">
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={key}
          variants={variants}
          initial="hidden"
          animate="visible"
          exit="hidden"
        >
          {icon}
        </motion.span>
      </AnimatePresence>
      { tooltip &&
        <div className="absolute right-0 bottom-full mb-spacing-2 w-auto inline-block whitespace-nowrap p-spacing-2 bg-bg-tooltip text-[12px] text-primary rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10 border border-border-default text-left">
          {tooltip}
        </div>
      }
    </div>
  )
}

